export default __webpack_public_path__ + "static/media/src_img_3.52bab078.png";